import type { DomainEnum } from '@empathybroker/tsclient-play/dist/enums/domain.enum'
import type { ActionContext } from 'vuex'
import type { ActionClass, ToolingState } from '../../../models'
import type { ToolConfigProvider } from '../../../providers/interfaces'
import { CONTAINER } from '../../../config/inversify.config'
import { TYPES } from '../../../config/inversify.types'
import { FeatureIdEnum } from '../../../enums'
import { TOOLING_CONSTS } from '../tooling.consts'

export class LoadToolConfigAction implements ActionClass {
  static async execute(
    this: void,
    { commit, state }: ActionContext<ToolingState, unknown>,
    { tool, domain }: { tool: string; domain?: DomainEnum },
  ): Promise<unknown> {
    let config: unknown
    if (state.tools.hasOwnProperty(tool)) {
      config = state.tools[tool].config
    } else {
      if (tool === FeatureIdEnum.RELATED_TAGS || tool === FeatureIdEnum.NEXT_QUERIES) {
        config =
          state.tools[FeatureIdEnum.RELATED_TAGS]?.config ??
          state.tools[FeatureIdEnum.NEXT_QUERIES]?.config
      }
      if (!config) {
        config = await CONTAINER.get<ToolConfigProvider>(TYPES.ToolConfigProvider)(tool, domain)
      }
      if (config) {
        commit(TOOLING_CONSTS.mutations.setState, { [tool]: { config } })
      }
    }
    return config
  }
}
